// src/data/countries.ts — ISO-3166-1 alpha-3 country list (static import)
// Auto-generated from olahol/iso-3166-2.json + lukes/ISO-3166-Countries-with-Regional-Codes
// Last updated: 2026-09-24
// v0.4.9.2.3c22a: replaces hardcoded country dropdowns across admin pages.

export interface CountryEntry {
  /** ISO-3166-1 alpha-3 code (e.g. "ESP", "BLR"). Canonical iSentinel360 storage form. */
  code: string;
  /** ISO-3166-1 alpha-2 code (e.g. "ES", "BY"). For reference / ISO-3166-2 prefix. */
  alpha2: string;
  /** English country name. */
  name: string;
}

export const COUNTRIES: ReadonlyArray<CountryEntry> = Object.freeze([
  { code: 'AFG', alpha2: 'AF', name: "Afghanistan", },
  { code: 'ALB', alpha2: 'AL', name: "Albania", },
  { code: 'DZA', alpha2: 'DZ', name: "Algeria", },
  { code: 'ASM', alpha2: 'AS', name: "American Samoa", },
  { code: 'AND', alpha2: 'AD', name: "Andorra", },
  { code: 'AGO', alpha2: 'AO', name: "Angola", },
  { code: 'AIA', alpha2: 'AI', name: "Anguilla", },
  { code: 'ATA', alpha2: 'AQ', name: "Antarctica", },
  { code: 'ATG', alpha2: 'AG', name: "Antigua & Barbuda", },
  { code: 'ARG', alpha2: 'AR', name: "Argentina", },
  { code: 'ARM', alpha2: 'AM', name: "Armenia", },
  { code: 'ABW', alpha2: 'AW', name: "Aruba", },
  { code: 'AUS', alpha2: 'AU', name: "Australia", },
  { code: 'AUT', alpha2: 'AT', name: "Austria", },
  { code: 'AZE', alpha2: 'AZ', name: "Azerbaijan", },
  { code: 'BHS', alpha2: 'BS', name: "Bahamas", },
  { code: 'BHR', alpha2: 'BH', name: "Bahrain", },
  { code: 'BGD', alpha2: 'BD', name: "Bangladesh", },
  { code: 'BRB', alpha2: 'BB', name: "Barbados", },
  { code: 'BLR', alpha2: 'BY', name: "Belarus", },
  { code: 'BEL', alpha2: 'BE', name: "Belgium", },
  { code: 'BLZ', alpha2: 'BZ', name: "Belize", },
  { code: 'BEN', alpha2: 'BJ', name: "Benin", },
  { code: 'BMU', alpha2: 'BM', name: "Bermuda", },
  { code: 'BTN', alpha2: 'BT', name: "Bhutan", },
  { code: 'BOL', alpha2: 'BO', name: "Bolivia", },
  { code: 'BIH', alpha2: 'BA', name: "Bosnia & Herzegovina", },
  { code: 'BWA', alpha2: 'BW', name: "Botswana", },
  { code: 'BVT', alpha2: 'BV', name: "Bouvet Island", },
  { code: 'BRA', alpha2: 'BR', name: "Brazil", },
  { code: 'IOT', alpha2: 'IO', name: "British Indian Ocean Territory", },
  { code: 'BRN', alpha2: 'BN', name: "Brunei Darussalam", },
  { code: 'BGR', alpha2: 'BG', name: "Bulgaria", },
  { code: 'BFA', alpha2: 'BF', name: "Burkina Faso", },
  { code: 'BDI', alpha2: 'BI', name: "Burundi", },
  { code: 'KHM', alpha2: 'KH', name: "Cambodia", },
  { code: 'CMR', alpha2: 'CM', name: "Cameroon", },
  { code: 'CAN', alpha2: 'CA', name: "Canada", },
  { code: 'CPV', alpha2: 'CV', name: "Cape Verde", },
  { code: 'CYM', alpha2: 'KY', name: "Cayman Islands", },
  { code: 'CAF', alpha2: 'CF', name: "Central African Republic", },
  { code: 'TCD', alpha2: 'TD', name: "Chad", },
  { code: 'CHL', alpha2: 'CL', name: "Chile", },
  { code: 'CHN', alpha2: 'CN', name: "China", },
  { code: 'CXR', alpha2: 'CX', name: "Christmas Island", },
  { code: 'CCK', alpha2: 'CC', name: "Cocos (Keeling) Islands", },
  { code: 'COL', alpha2: 'CO', name: "Colombia", },
  { code: 'COM', alpha2: 'KM', name: "Comoros", },
  { code: 'COG', alpha2: 'CG', name: "Congo", },
  { code: 'COK', alpha2: 'CK', name: "Cook Islands", },
  { code: 'CRI', alpha2: 'CR', name: "Costa Rica", },
  { code: 'CIV', alpha2: 'CI', name: "Cote D'ivoire (Ivory Coast)", },
  { code: 'HRV', alpha2: 'HR', name: "Croatia (Hrvatska)", },
  { code: 'CUB', alpha2: 'CU', name: "Cuba", },
  { code: 'CYP', alpha2: 'CY', name: "Cyprus", },
  { code: 'CZE', alpha2: 'CZ', name: "Czech Republic", },
  { code: 'DNK', alpha2: 'DK', name: "Denmark", },
  { code: 'DJI', alpha2: 'DJ', name: "Djibouti", },
  { code: 'DMA', alpha2: 'DM', name: "Dominica", },
  { code: 'DOM', alpha2: 'DO', name: "Dominican Republic", },
  { code: 'ECU', alpha2: 'EC', name: "Ecuador", },
  { code: 'EGY', alpha2: 'EG', name: "Egypt", },
  { code: 'SLV', alpha2: 'SV', name: "El Salvador", },
  { code: 'GNQ', alpha2: 'GQ', name: "Equatorial Guinea", },
  { code: 'ERI', alpha2: 'ER', name: "Eritrea", },
  { code: 'EST', alpha2: 'EE', name: "Estonia", },
  { code: 'ETH', alpha2: 'ET', name: "Ethiopia", },
  { code: 'FLK', alpha2: 'FK', name: "Falkland Islands (Malvinas)", },
  { code: 'FRO', alpha2: 'FO', name: "Faroe Islands", },
  { code: 'FJI', alpha2: 'FJ', name: "Fiji", },
  { code: 'FIN', alpha2: 'FI', name: "Finland", },
  { code: 'FRA', alpha2: 'FR', name: "France", },
  { code: 'GUF', alpha2: 'GF', name: "French Guiana", },
  { code: 'PYF', alpha2: 'PF', name: "French Polynesia", },
  { code: 'ATF', alpha2: 'TF', name: "French Southern Territories", },
  { code: 'GAB', alpha2: 'GA', name: "Gabon", },
  { code: 'GMB', alpha2: 'GM', name: "Gambia", },
  { code: 'GEO', alpha2: 'GE', name: "Georgia", },
  { code: 'DEU', alpha2: 'DE', name: "Germany", },
  { code: 'GHA', alpha2: 'GH', name: "Ghana", },
  { code: 'GIB', alpha2: 'GI', name: "Gibraltar", },
  { code: 'GRC', alpha2: 'GR', name: "Greece", },
  { code: 'GRL', alpha2: 'GL', name: "Greenland", },
  { code: 'GRD', alpha2: 'GD', name: "Grenada", },
  { code: 'GLP', alpha2: 'GP', name: "Guadeloupe", },
  { code: 'GUM', alpha2: 'GU', name: "Guam", },
  { code: 'GTM', alpha2: 'GT', name: "Guatemala", },
  { code: 'GIN', alpha2: 'GN', name: "Guinea", },
  { code: 'GNB', alpha2: 'GW', name: "Guinea-Bissau", },
  { code: 'GUY', alpha2: 'GY', name: "Guyana", },
  { code: 'HTI', alpha2: 'HT', name: "Haiti", },
  { code: 'HMD', alpha2: 'HM', name: "Heard & McDonald Islands", },
  { code: 'HND', alpha2: 'HN', name: "Honduras", },
  { code: 'HKG', alpha2: 'HK', name: "Hong Kong", },
  { code: 'HUN', alpha2: 'HU', name: "Hungary", },
  { code: 'ISL', alpha2: 'IS', name: "Iceland", },
  { code: 'IND', alpha2: 'IN', name: "India", },
  { code: 'IDN', alpha2: 'ID', name: "Indonesia", },
  { code: 'IRN', alpha2: 'IR', name: "Iran", },
  { code: 'IRQ', alpha2: 'IQ', name: "Iraq", },
  { code: 'IRL', alpha2: 'IE', name: "Ireland", },
  { code: 'ISR', alpha2: 'IL', name: "Israel", },
  { code: 'ITA', alpha2: 'IT', name: "Italy", },
  { code: 'JAM', alpha2: 'JM', name: "Jamaica", },
  { code: 'JPN', alpha2: 'JP', name: "Japan", },
  { code: 'JOR', alpha2: 'JO', name: "Jordan", },
  { code: 'KAZ', alpha2: 'KZ', name: "Kazakhstan", },
  { code: 'KEN', alpha2: 'KE', name: "Kenya", },
  { code: 'KIR', alpha2: 'KI', name: "Kiribati", },
  { code: 'PRK', alpha2: 'KP', name: "Korea (North)", },
  { code: 'KOR', alpha2: 'KR', name: "Korea (South)", },
  { code: 'KWT', alpha2: 'KW', name: "Kuwait", },
  { code: 'KGZ', alpha2: 'KG', name: "Kyrgyzstan", },
  { code: 'LAO', alpha2: 'LA', name: "Laos", },
  { code: 'LVA', alpha2: 'LV', name: "Latvia", },
  { code: 'LBN', alpha2: 'LB', name: "Lebanon", },
  { code: 'LSO', alpha2: 'LS', name: "Lesotho", },
  { code: 'LBR', alpha2: 'LR', name: "Liberia", },
  { code: 'LBY', alpha2: 'LY', name: "Libya", },
  { code: 'LIE', alpha2: 'LI', name: "Liechtenstein", },
  { code: 'LTU', alpha2: 'LT', name: "Lithuania", },
  { code: 'LUX', alpha2: 'LU', name: "Luxembourg", },
  { code: 'MAC', alpha2: 'MO', name: "Macau", },
  { code: 'MKD', alpha2: 'MK', name: "Macedonia", },
  { code: 'MDG', alpha2: 'MG', name: "Madagascar", },
  { code: 'MWI', alpha2: 'MW', name: "Malawi", },
  { code: 'MYS', alpha2: 'MY', name: "Malaysia", },
  { code: 'MDV', alpha2: 'MV', name: "Maldives", },
  { code: 'MLI', alpha2: 'ML', name: "Mali", },
  { code: 'MLT', alpha2: 'MT', name: "Malta", },
  { code: 'MHL', alpha2: 'MH', name: "Marshall Islands", },
  { code: 'MTQ', alpha2: 'MQ', name: "Martinique", },
  { code: 'MRT', alpha2: 'MR', name: "Mauritania", },
  { code: 'MUS', alpha2: 'MU', name: "Mauritius", },
  { code: 'MYT', alpha2: 'YT', name: "Mayotte", },
  { code: 'MEX', alpha2: 'MX', name: "Mexico", },
  { code: 'FSM', alpha2: 'FM', name: "Micronesia", },
  { code: 'MDA', alpha2: 'MD', name: "Moldova", },
  { code: 'MCO', alpha2: 'MC', name: "Monaco", },
  { code: 'MNG', alpha2: 'MN', name: "Mongolia", },
  { code: 'MSR', alpha2: 'MS', name: "Montserrat", },
  { code: 'MAR', alpha2: 'MA', name: "Morocco", },
  { code: 'MOZ', alpha2: 'MZ', name: "Mozambique", },
  { code: 'MMR', alpha2: 'MM', name: "Myanmar", },
  { code: 'NAM', alpha2: 'NA', name: "Namibia", },
  { code: 'NRU', alpha2: 'NR', name: "Nauru", },
  { code: 'NPL', alpha2: 'NP', name: "Nepal", },
  { code: 'NLD', alpha2: 'NL', name: "Netherlands", },
  { code: 'NCL', alpha2: 'NC', name: "New Caledonia", },
  { code: 'NZL', alpha2: 'NZ', name: "New Zealand", },
  { code: 'NIC', alpha2: 'NI', name: "Nicaragua", },
  { code: 'NER', alpha2: 'NE', name: "Niger", },
  { code: 'NGA', alpha2: 'NG', name: "Nigeria", },
  { code: 'NIU', alpha2: 'NU', name: "Niue", },
  { code: 'NFK', alpha2: 'NF', name: "Norfolk Island", },
  { code: 'MNP', alpha2: 'MP', name: "Northern Mariana Islands", },
  { code: 'NOR', alpha2: 'NO', name: "Norway", },
  { code: 'OMN', alpha2: 'OM', name: "Oman", },
  { code: 'PAK', alpha2: 'PK', name: "Pakistan", },
  { code: 'PLW', alpha2: 'PW', name: "Palau", },
  { code: 'PAN', alpha2: 'PA', name: "Panama", },
  { code: 'PNG', alpha2: 'PG', name: "Papua New Guinea", },
  { code: 'PRY', alpha2: 'PY', name: "Paraguay", },
  { code: 'PER', alpha2: 'PE', name: "Peru", },
  { code: 'PHL', alpha2: 'PH', name: "Philippines", },
  { code: 'PCN', alpha2: 'PN', name: "Pitcairn", },
  { code: 'POL', alpha2: 'PL', name: "Poland", },
  { code: 'PRT', alpha2: 'PT', name: "Portugal", },
  { code: 'PRI', alpha2: 'PR', name: "Puerto Rico", },
  { code: 'QAT', alpha2: 'QA', name: "Qatar", },
  { code: 'REU', alpha2: 'RE', name: "Reunion", },
  { code: 'ROU', alpha2: 'RO', name: "Romania", },
  { code: 'RUS', alpha2: 'RU', name: "Russian Federation", },
  { code: 'RWA', alpha2: 'RW', name: "Rwanda", },
  { code: 'SGS', alpha2: 'GS', name: "S.Georgia & S.Sandwich Islands", },
  { code: 'KNA', alpha2: 'KN', name: "Saint Kitts & Nevis", },
  { code: 'LCA', alpha2: 'LC', name: "Saint Lucia", },
  { code: 'WSM', alpha2: 'WS', name: "Samoa", },
  { code: 'SMR', alpha2: 'SM', name: "San Marino", },
  { code: 'STP', alpha2: 'ST', name: "Sao Tome & Principe", },
  { code: 'SAU', alpha2: 'SA', name: "Saudi Arabia", },
  { code: 'SEN', alpha2: 'SN', name: "Senegal", },
  { code: 'SYC', alpha2: 'SC', name: "Seychelles", },
  { code: 'SLE', alpha2: 'SL', name: "Sierra Leone", },
  { code: 'SGP', alpha2: 'SG', name: "Singapore", },
  { code: 'SVK', alpha2: 'SK', name: "Slovak Republic", },
  { code: 'SVN', alpha2: 'SI', name: "Slovenia", },
  { code: 'SLB', alpha2: 'SB', name: "Solomon Islands", },
  { code: 'SOM', alpha2: 'SO', name: "Somalia", },
  { code: 'ZAF', alpha2: 'ZA', name: "South Africa", },
  { code: 'ESP', alpha2: 'ES', name: "Spain", },
  { code: 'LKA', alpha2: 'LK', name: "Sri Lanka", },
  { code: 'SHN', alpha2: 'SH', name: "St. Helena", },
  { code: 'SPM', alpha2: 'PM', name: "St. Pierre & Miquelon", },
  { code: 'VCT', alpha2: 'VC', name: "St. Vincent & the Grenadines", },
  { code: 'SDN', alpha2: 'SD', name: "Sudan", },
  { code: 'SUR', alpha2: 'SR', name: "Suriname", },
  { code: 'SJM', alpha2: 'SJ', name: "Svalbard & Jan Mayen Islands", },
  { code: 'SWZ', alpha2: 'SZ', name: "Swaziland", },
  { code: 'SWE', alpha2: 'SE', name: "Sweden", },
  { code: 'CHE', alpha2: 'CH', name: "Switzerland", },
  { code: 'SYR', alpha2: 'SY', name: "Syria", },
  { code: 'TWN', alpha2: 'TW', name: "Taiwan", },
  { code: 'TJK', alpha2: 'TJ', name: "Tajikistan", },
  { code: 'TZA', alpha2: 'TZ', name: "Tanzania", },
  { code: 'THA', alpha2: 'TH', name: "Thailand", },
  { code: 'TGO', alpha2: 'TG', name: "Togo", },
  { code: 'TKL', alpha2: 'TK', name: "Tokelau", },
  { code: 'TON', alpha2: 'TO', name: "Tonga", },
  { code: 'TTO', alpha2: 'TT', name: "Trinidad & Tobago", },
  { code: 'TUN', alpha2: 'TN', name: "Tunisia", },
  { code: 'TUR', alpha2: 'TR', name: "Turkey", },
  { code: 'TKM', alpha2: 'TM', name: "Turkmenistan", },
  { code: 'TCA', alpha2: 'TC', name: "Turks & Caicos Islands", },
  { code: 'TUV', alpha2: 'TV', name: "Tuvalu", },
  { code: 'UGA', alpha2: 'UG', name: "Uganda", },
  { code: 'UKR', alpha2: 'UA', name: "Ukraine", },
  { code: 'ARE', alpha2: 'AE', name: "United Arab Emirates", },
  { code: 'GBR', alpha2: 'GB', name: "United Kingdom", },
  { code: 'USA', alpha2: 'US', name: "United States", },
  { code: 'URY', alpha2: 'UY', name: "Uruguay", },
  { code: 'UZB', alpha2: 'UZ', name: "Uzbekistan", },
  { code: 'VUT', alpha2: 'VU', name: "Vanuatu", },
  { code: 'VAT', alpha2: 'VA', name: "Vatican City (Holy See)", },
  { code: 'VEN', alpha2: 'VE', name: "Venezuela", },
  { code: 'VNM', alpha2: 'VN', name: "Viet Nam", },
  { code: 'VGB', alpha2: 'VG', name: "Virgin Islands (British)", },
  { code: 'VIR', alpha2: 'VI', name: "Virgin Islands (U.S.)", },
  { code: 'WLF', alpha2: 'WF', name: "Wallis & Futuna Islands", },
  { code: 'ESH', alpha2: 'EH', name: "Western Sahara", },
  { code: 'YEM', alpha2: 'YE', name: "Yemen", },
  { code: 'COD', alpha2: 'CD', name: "Zaire", },
  { code: 'ZMB', alpha2: 'ZM', name: "Zambia", },
  { code: 'ZWE', alpha2: 'ZW', name: "Zimbabwe", },
]);

/** Lookup: alpha-3 code → country entry. */
export function findCountry(code: string): CountryEntry | undefined {
  return COUNTRIES.find(c => c.code === code);
}
